import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css/bundle';
import MobileDetect from "mobile-detect";
import {TealiumClickModel} from "../tracking/tealium-model";

document.addEventListener("DOMContentLoaded", (event) => {
    function MainlaneControl() {
        let _self = this;
        this.dataCurrent = null;
        this.slider = null;
        this.djsMediaPlayer = null;
        this.videoPlayer = null;
        this.postFullscreen = false;
        this.currentTime = false;
        this.md = new MobileDetect(window.navigator.userAgent);
        this.autoplay = (document.getElementById('mainlane'))
            ? document.getElementById('mainlane').dataset.autoplay === '1'
            : false;
        this.isPlaying = (document.getElementById('mainlane'))
            ? document.getElementById('mainlane').dataset.autoplay === '1'
            : false;
        this.volume = (this.autoplay) ? 0 : 1;
        this.btnVolumeOn = '<i class="fa fa-volume-up"></i><span class="btn-text" title="Ton anschalten"> Ton an</span>';
        this.btnVolumeOff = '<i class="fa fa-volume-down"></i><span class="btn-text" title="Ton ausschalten"> Ton aus</span>';
        this.btnPlayPauseOn = '<i class="fa fa-pause"></i><span class="btn-text" title="Pause"></span>';
        this.btnPlayPauseOff = '<i class="fa fa-play"></i><span class="btn-text" title="Play"></span>';
        this.btnDetails = '<i class="fa fa-info-circle"></i><span class="btn-text" title="Details"> Details</span>';
        this.toggleVolume = function () {
            _self.volume = _self.volume === 1 ? 0 : 1;

            if (_self.videoPlayer) {
                if (_self.volume === 1) {
                    _self.videoPlayer.muted = false;
                } else {
                    _self.videoPlayer.muted = true;
                }
            }

            let muteBtn = document.getElementById('mainlane-mute');
            muteBtn.innerHTML = _self.getBtnVolume();

            if (_self.djsMediaPlayer) {
                _self.djsMediaPlayer.setVolume(_self.volume);
            }
            if (_self.videoPlayer) {
                _self.videoPlayer.volume = _self.volume;
            }
            return false;
        };
        this.togglePlayPause = function () {
            _self.isPlaying = !_self.isPlaying;

            if (
                _self.dataCurrent.type === 'streamplayer'
                && _self.djsMediaPlayer === null
                && _self.dataCurrent.useHls === undefined
            ) {
                SK.mainlane.initializeStreamPlayer(_self.dataCurrent.mpd);
            } else {
                if (_self.djsMediaPlayer !== null) {
                    if (SK.mainlane.isPlaying) {
                        _self.djsMediaPlayer.play();
                    } else {
                        _self.djsMediaPlayer.pause();
                    }
                } else if (_self.videoPlayer !== null) {
                    if (SK.mainlane.isPlaying) {
                        _self.videoPlayer.play();
                    } else {
                        _self.videoPlayer.pause();
                    }
                }
            }

            let playBtn = document.getElementById('mainlane-play');
            playBtn.innerHTML = _self.getBtnPlayPause();

            return false;
        };
        this.getBtnVolume = function () {
            if (_self.volume === 1) {
                return _self.btnVolumeOff;
            } else {
                return _self.btnVolumeOn;
            }
        }
        this.getBtnPlayPause = function () {
            if (_self.isPlaying) {
                return _self.btnPlayPauseOn;
            } else {
                return _self.btnPlayPauseOff;
            }
        }
        this.utag = function (action) {
            if (_self.dataCurrent.type === 'streamplayer') {
                let utagDetail = new TealiumClickModel({
                    link_action: action,
                    link_value: 'Live TV',
                    link_category: 'mediathek'
                });
                utag.link(utagDetail.getUtagClickOptions());
                console.log('🌞 utag.link()', utagDetail.getUtagClickOptions());
            } else {
                let utagDetail = new TealiumClickModel({
                    link_action: action,
                    link_value: _self.dataCurrent.id + '-' + _self.dataCurrent.title,
                    link_category: 'mediathek'
                });
                utag.link(utagDetail.getUtagClickOptions());
                console.log('🌞 utag.link()', utagDetail.getUtagClickOptions());
            }
        },
        /**
         * create ui buttons and headers for current video slider element
         * @param data string|object
         * @returns {HTMLDivElement}
         */
        this.getVideoHeader = function () {
            let _self = this;
            let bWrap = document.createElement('div');
            bWrap.classList.add('mainlane-video-header');

            if (typeof _self.dataCurrent.title !== 'undefined' && _self.dataCurrent.title !== '') {
                let headLines = document.createElement('div');
                headLines.classList.add('video-headlines');
                headLines.innerHTML = `<h5 class="title">${_self.dataCurrent.title}</h5><h6><i class="fa fa-map-marker"></i> ${_self.dataCurrent.destination}</h6>`;
                bWrap.append(headLines);
            }

            let btnsToAppend = [];

            if (_self.dataCurrent.type === 'streamplayer') {
                let liveTV = document.createElement('div');
                liveTV.title = 'Live im TV';
                liveTV.classList.add('btn', 'btn-success', 'btn-mainlane', 'btn-livetv');
                liveTV.innerHTML = 'Live<br>TV';
                btnsToAppend.push(liveTV);
            }

            let detail = document.createElement('a');
            if (_self.dataCurrent.type === 'streamplayer') {
                detail.href = _self.dataCurrent.uri || data;
            }
            detail.title = 'Details anzeigen';
            detail.classList.add('btn', 'btn-success', 'btn-mainlane', 'btn-details', 'pointer');
            detail.innerHTML = _self.btnDetails;
            detail.onclick = function (ev) {
               _self.utag('details');
            };
            btnsToAppend.push(detail)

            let mute = document.createElement('a');
            mute.href = '#';
            mute.id = 'mainlane-mute';
            mute.classList.add('btn', 'btn-success', 'btn-mainlane', 'btn-mute');

            mute.onclick = function (ev) {
                _self.utag('mute/unmute');
                SK.mainlane.toggleVolume()
                ev.preventDefault();
                ev.stopPropagation();
            };
            mute.innerHTML = _self.getBtnVolume();
            btnsToAppend.push(mute);

            let play = document.createElement('a');
            play.href = '#';
            play.id = 'mainlane-play';
            play.classList.add('btn', 'btn-success', 'btn-mainlane', 'btn-play');

            play.onclick = function (ev) {
                _self.utag('play/pause');
                SK.mainlane.togglePlayPause()
                ev.preventDefault();
                ev.stopPropagation();
            };
            play.innerHTML = _self.getBtnPlayPause();
            btnsToAppend.push(play);

            bWrap.append(...btnsToAppend);

            return bWrap;
        }
        this.removeElementsByClassName = function (className) {
            let elements = document.getElementsByClassName(className);
            for (let i = elements.length - 1; i >= 0; i--) {
                elements[i].remove();
            }
        }
        this.removeElementsByTagName = function (tagName) {
            let elements = document.getElementsByTagName(tagName);
            for (let i = elements.length - 1; i >= 0; i--) {
                elements[i].remove();
            }
        }
        this.removeClassOfElementsWithClassName = function (searchClass, removeClass) {
            let elements = document.getElementsByClassName(searchClass);
            for (let i = elements.length - 1; i >= 0; i--) {
                elements[i].classList.remove(removeClass);
            }
        }

        this.initializeStreamPlayer = function (src) {
            document.querySelector("#streamplayer")
                .previousElementSibling
                .previousElementSibling
                .classList.add('poster-hidden')
            _self.djsMediaPlayer = dashjs.MediaPlayer().create();
            _self.djsMediaPlayer.initialize(document.querySelector("#streamplayer"), src, true);
            _self.isPlaying = true;
        }
    }

    window.SK.mainlane = new MainlaneControl();

    Swiper.use([Navigation]);
    let mainlaneSlider = new Swiper('.tx-mediathek-mainlane .swiper', {
        autoplay: false,
        observer: true,
        observeParents: true,
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        spaceBetween: 30,
        centeredSlides: true,
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 0
            },
            480: {
                slidesPerView: 1.23,
                spaceBetween: 5
            },
            769: {
                slidesPerView: 1.43,
                spaceBetween: 5
            },
            1024: {
                slidesPerView: 1.7,
                spaceBetween: 5
            },
            1280: {
                slidesPerView: 2,
                spaceBetween: 5
            }

        },
        on: {
            init: function () {
            },
            transitionStart: function () {
                if (SK.mainlane.postFullscreen === true) {
                    if (SK.mainlane.videoPlayer) {
                        SK.mainlane.currentTime = SK.mainlane.videoPlayer.currentTime;
                    }
                }
                if (document.fullscreen === true) {
                    SK.mainlane.postFullscreen = true;
                }
                SK.mainlane.removeElementsByClassName('mainlane-video-header');
                if (!SK.mainlane.autoplay) {
                    SK.mainlane.isPlaying = false;
                }
            },
            transitionEnd: function () {
                let _self = this;

                if (SK.mainlane.postFullscreen) {
                    SK.mainlane.postFullscreen = false;
                    return;
                }
                if (SK.mainlane.djsMediaPlayer !== null) {
                    SK.mainlane.djsMediaPlayer.pause();
                    SK.mainlane.djsMediaPlayer.reset();
                    SK.mainlane.djsMediaPlayer = null;
                }
                if (SK.mainlane.videoPlayer !== null) {
                    SK.mainlane.videoPlayer.pause();
                    SK.mainlane.videoPlayer = null;
                }

                SK.mainlane.removeClassOfElementsWithClassName('poster-hidden', 'poster-hidden');
                SK.mainlane.removeElementsByTagName('video');

                SK.mainlane.dataCurrent = this.slides[this.activeIndex].dataset;

                this.slides[this.activeIndex].getElementsByTagName('img')[0].classList.add('poster-hidden');

                let vid = document.createElement('video');
                vid.poster = SK.mainlane.dataCurrent.poster;
                vid.width = 640;
                vid.height = 360;
                vid.controls = false;
                vid.autoplay = SK.mainlane.autoplay && SK.mainlane.isPlaying;
                vid.playsInline = true;

                vid.volume = SK.mainlane.volume;
                if ((SK.mainlane.md.is('iPhone') || SK.mainlane.md.match('iPad') || SK.mainlane.md.match('Macintosh')) && SK.mainlane.volume === 0) {
                    vid.muted = true;
                } else {
                    vid.muted = false;
                }

                if (SK.mainlane.dataCurrent.type === 'mp4') {
                    console.info('🌞️ video mainlane: using mp4');
                    vid.id = 'mp4player';
                    vid.src = SK.mainlane.dataCurrent.src;
                    vid.title = SK.mainlane.dataCurrent.title;
                    vid.onclick = function (evt) {
                        evt.stopPropagation();
                    }
                    vid.onended = function () {
                        SK.mainlane.slideNext();
                    }
                    if (SK.mainlane.postFullscreen) {
                        vid.currentTime = SK.mainlane.currentTime;
                        SK.mainlane.currentTime = false;
                    }
                    SK.mainlane.videoPlayer = vid;

                    this.slides[this.activeIndex].append(vid);
                } else if (SK.mainlane.dataCurrent.type === 'streamplayer') {
                    vid.id = 'streamplayer';
                    vid.title = 'SKTV Live TV-Stream';
                    vid.onclick = function (evt) {
                        evt.stopPropagation();
                    }

                    if (
                        (
                            SK.mainlane.md.is('iPhone')
                            || SK.mainlane.md.match('iPad')
                            || SK.mainlane.md.match('Macintosh')
                        )
                        && !SK.mainlane.md.match('Firefox')
                        && !SK.mainlane.md.match('Chrome')
                    ) {
                        // use HLS video source
                        console.info('🌞️ stream-player mainlane: using HLS/m3u8 for Safari');
                        let source = document.createElement('source');
                        source.src = SK.mainlane.dataCurrent.hls;
                        source.type = "application/x-mpegurl";
                        vid.append(source);
                        SK.mainlane.dataCurrent.useHls = true;
                        SK.mainlane.videoPlayer = vid;
                        this.slides[this.activeIndex].append(vid);
                    } else {
                        // use dash.js player
                        console.info('🌞️ stream-player mainlane: using djs');
                        SK.mainlane.videoPlayer = vid;
                        this.slides[this.activeIndex].append(vid);
                        if (SK.mainlane.autoplay) {
                            SK.mainlane.initializeStreamPlayer(SK.mainlane.dataCurrent.mpd);
                        }
                    }
                }

                _self.slides[_self.activeIndex].append(SK.mainlane.getVideoHeader());
            }
        }
    });

    window.SK.mainlane.slider = mainlaneSlider;

    console.log('🌞️ Mainlane initialized');
});